import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { deleteCDGRJobApi, getCDGRJobsApi, loadCDGRJobApi, saveCDGRJobApi } from '../api/cdgrJobApi';


export const getCDGRJobs = createAsyncThunk(
  'cdgrJobs/getCDGRJobs',
  async () => {
    try {
      const cdgrJobs = await getCDGRJobsApi();
      return cdgrJobs;
    } catch (err) {
      return null;
    };
  }
);

export const loadCDGRJob = createAsyncThunk(
  'cdgrJobs/loadCDGRJob',
  async (location) => {
    try {
      const cdgrJob = await loadCDGRJobApi(location);
      return cdgrJob;
    } catch (err) {
      return null;
    };
  }
);

export const saveCDGRJob = createAsyncThunk(
  'cdgrJobs/saveCDGRJob',
  async (payload) => {
    try {
      const cdgrJob = await saveCDGRJobApi(payload);
      return cdgrJob;
    } catch (err) {
      return null;
    };
  }
);

export const deleteCDGRJob = createAsyncThunk(
  'cdgrJobs/deleteCDGRJob',
  async (cdgrJobId, { getState}) => {
    try {
      const state = getState();
      const email = state?.user?.value?.email;

      await deleteCDGRJobApi(cdgrJobId, email);
      return cdgrJobId;
    } catch (err) {
      return cdgrJobId;
    };
  }
);

export const cdgrJobSlice = createSlice({
  name: 'cdgrJobs',
  initialState: {
    byId: {},
    allIds: [],
    currentCDGRJobId: "",
  },
  reducers: {
    addCDGRJob: (state, action) => {
      try {
        const cdgrJob = action.payload;
        const cdgrJobId = cdgrJob?.id
        if (state.allIds.indexOf(cdgrJobId) === -1) {
          state.allIds.push(cdgrJobId);
        };
        const checkedWells = cdgrJob?.checkedWells?.length > 0 ? cdgrJob?.checkedWells : (state.byId[cdgrJobId]?.checkedWells || []);
        const location = state.byId[cdgrJobId]?.location || "";
        state.byId[cdgrJobId] = {...cdgrJob, checkedWells, location};
        state.currentCDGRJobId = cdgrJobId;
      } catch (error) {
        return;
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCDGRJobs.fulfilled, (state, action) => {
      try {
        if (!state.allIds?.length > 0) {
          const cdgrJobs = action.payload;
          for (let cdgrJob of cdgrJobs) {
            if (cdgrJob) {
              const cdgrJobId = cdgrJob?.id
              if (cdgrJobId && state.allIds.indexOf(cdgrJobId) === -1) {
                state.allIds.push(cdgrJobId);
              };
              state.byId[cdgrJobId] = cdgrJob;
              state.currentCDGRJobId = cdgrJobId;
            };
          };
        };
      } catch (error) {
        return;  
      };
    })
    builder.addCase(loadCDGRJob.fulfilled, (state, action) => {
      try {
        const cdgrJob = action.payload;
        if (cdgrJob) {
          const cdgrJobId = cdgrJob?.id
          if (cdgrJobId && state.allIds.indexOf(cdgrJobId) === -1) {
            state.allIds.push(cdgrJobId);
          };
          const checkedWells = state.byId[cdgrJobId]?.checkedWells || [];
          const location = state.byId[cdgrJobId]?.location || "";
          state.byId[cdgrJobId] = {...cdgrJob, checkedWells, location};
          state.currentCDGRJobId = cdgrJobId;
        };
      } catch (error) {
        return;  
      };
    })
    builder.addCase(deleteCDGRJob.fulfilled, (state, action) => {
      try {
        const cdgrJobId = action.payload;
        state.allIds = state.allIds.filter(id => id !== cdgrJobId);
        delete state.byId[cdgrJobId];
        if (state.currentCDGRJobId === cdgrJobId) {
          state.currentCDGRJobId = state.allIds?.[0] || ""
        };
      } catch (error) {
        return;  
      };
    })
  },
})

export const { 
  addCDGRJob
} = cdgrJobSlice.actions;

export const selectCDGRJobs = (state) => state.cdgrJobs;

export default cdgrJobSlice.reducer;